// AuthInitializer.tsx
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks";
import { clearToken, setToken } from "./authSlice";



function AuthInitializer() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchToken = async () => {
      if (isAuthenticated) {
        const tk = await getAccessTokenSilently();
    
        dispatch(setToken(tk));
      } else {
        dispatch(clearToken());
      }
    };
    fetchToken();
  }, [isAuthenticated, getAccessTokenSilently, dispatch]);

  return null;
}

export default AuthInitializer;
